import React, { useEffect, useMemo, useState } from "react";

import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCardSubtitle,
  CCardTitle,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CListGroup,
  CListGroupItem,
  CProgress,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { InputGroup, Label } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Charts from "../../../../components/Charts";
import LoadingStatistics from "../../../../components/LoadingStatistics";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import StatisticFiltersCompare from "../../../../components/StatisticFiltersCompare";
import TextEditorReadOnly from "../../../../components/TextEditorReadOnly/TextEditorReadOnly";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";
import Statistics from "../../List/statistics";

const EvaluationADRReport = props => {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [statisticsModal, setStatisticsModal] = useState(false);

  const [dataGrades, setDataGrades] = useState([]);
  const [dataCorrectsByQuestion, setDataCorrectsByQuestion] = useState([]);
  const [dataCorrectsByAbility, setDataCorrectsByAbility] = useState([]);
  const [dataDescriptor, setDescriptor] = useState([]);
  const [dataComparison, setDataComparison] = useState([]);
  const [dataComparisonStudentRoom, setDataComparisonStudentRoom] = useState(
    []
  );
  const [dataCorrectsUnit, setDataCorrectsUnit] = useState([]);
  const [dataHistogramStudent, setDataHistogramStudent] = useState([]);
  const [dataStudentAbility, setDataStudentAbility] = useState([]);
  const [photo, setPhoto] = useState(null);
  const [evaluationList, setEvaluationList] = useState([]);
  const [activityId, setActivityId] = useState(0);

  useEffect(() => {
    axios
      .get(`${URL.api}activity/activity/listEvaluationsByAllocation`, {
        headers: { authorization: `Bearer ${props.user.token}` },
        params: { user_id: props.user.user?.id }
      })
      .then(resp => {
        setEvaluationList(resp.data.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${URL.api}access/role/getMenuPhoto`, {
        params: {
          school_id: props.general.active_roles.school_id,
          group_id: props.general.active_roles.group_id
        },
        headers: { authorization: `Bearer ${props.user.token}` }
      })
      .then(resp => {
        setPhoto(resp.data.data);
      });
  }, []);

  const changeFilter = selected => {
    setLoading(true);
    setSelected(selected);

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      activity_id: activityId
    };

    if (selected.userId === 0) {
      axios
        .all([
          axios.get(`${URL.api}statistics/evaluation_grades`, {
            params,
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_corrects`, {
            params: { ...params, type: "question" },
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_descriptor_distractor`, {
            params,
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_corrects`, {
            params: { ...params, type: "ability" },
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_corrects`, {
            params: { ...params, type: "thematic_unit" },
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_comparison`, {
            params,
            headers: { authorization: `Bearer ${props.user.token}` }
          })
        ])
        .then(
          axios.spread(
            (
              respGrades,
              respQuestions,
              respDescriptor,
              respAbility,
              respCorrectUnit,
              respComparison
            ) => {
              setDataGrades(respGrades.data.data);
              setDataCorrectsByQuestion(respQuestions.data.data);
              setDescriptor(respDescriptor.data.data);
              setDataCorrectsByAbility(respAbility.data.data);
              setDataCorrectsUnit(respCorrectUnit.data.data);
              setDataComparison(respComparison.data.data);
              setLoading(false);
            }
          )
        );
    } else if (selected.userId > 0) {
      axios
        .all([
          axios.get(`${URL.api}statistics/evaluation_compare_student_room`, {
            params: { ...params, user_id: selected.userId },
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_grades`, {
            params,
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_compare_unit_ability`, {
            params: { ...params, user_id: selected.userId },
            headers: { authorization: `Bearer ${props.user.token}` }
          }),
          axios.get(`${URL.api}statistics/evaluation_histograms`, {
            params: { ...params, user_id: selected.userId },
            headers: { authorization: `Bearer ${props.user.token}` }
          })
        ])
        .then(
          axios.spread(
            (
              respCompareStudentRoom,
              respGrades,
              respStudentAbility,
              respHistogramStudent
            ) => {
              setDataComparisonStudentRoom(respCompareStudentRoom.data.data);
              setDataGrades(respGrades.data.data);
              setDataStudentAbility(respStudentAbility.data.data);
              setDataHistogramStudent(respHistogramStudent.data.data);
              setLoading(false);
            }
          )
        );
    }
  };

  const getCorrects = questionId => {
    if (
      !dataCorrectsByQuestion.applications ||
      !dataCorrectsByQuestion.questions
    ) {
      return "";
    }

    const correct = dataCorrectsByQuestion.applications.find(
      item => item.question_id === questionId && item.correct
    )?.count;

    return correct || 0;
  };

  const getOptionPercentage = (question, option) => {
    const checkedTotal = question.options.reduce(
      (acc, val) => acc + val.checked_by,
      0
    );

    if (checkedTotal === 0) {
      return 0;
    }

    return (option.checked_by / checkedTotal) * 100;
  };

  const isDistractor = (question, option) => {
    const distractorValue = question.options.reduce(
      (acc, val) => Math.max(acc, val.check_value ? 0 : val.checked_by),
      0
    );

    if (distractorValue > 0 && distractorValue === option.checked_by)
      return true;

    return false;
  };

  const getPercentage = questionId => {
    if (
      !dataCorrectsByQuestion.applications ||
      !dataCorrectsByQuestion.questions
    ) {
      return 0;
    }

    const correct =
      dataCorrectsByQuestion.applications.find(
        item => item.question_id === questionId && item.correct
      )?.count || 0;
    const notCorrect =
      dataCorrectsByQuestion.applications.find(
        item => item.question_id === questionId && !item.correct
      )?.count || 0;
    const total = correct + notCorrect;

    if (total === 0) {
      return 0;
    }

    return (correct / total) * 100;
  };

  const formatAbility = (ability, ellipsis = false) => {
    const text = ability.description
      ? `${ability.code ? `(${ability.code}) ` : ""}${ability.description}`
      : "(Sem habilidade)";

    if (!ellipsis || text.length < 50) return text;

    return `${text.substring(0, 50)}...`;
  };

  const getCorrectsAbility = abilityId => {
    if (
      !dataCorrectsByAbility.applications ||
      !dataCorrectsByAbility.abilities
    ) {
      return "";
    }

    const correct = dataCorrectsByAbility.applications.find(
      item => item.ability_id === abilityId && item.correct
    )?.count;

    return correct || 0;
  };

  const getPercentageAbility = abilityId => {
    if (
      !dataCorrectsByAbility.applications ||
      !dataCorrectsByAbility.abilities
    ) {
      return 0;
    }

    const correct =
      dataCorrectsByAbility.applications.find(
        item => item.ability_id === abilityId && item.correct
      )?.count || 0;
    const notCorrect =
      dataCorrectsByAbility.applications.find(
        item => item.ability_id === abilityId && !item.correct
      )?.count || 0;
    const total = correct + notCorrect;

    if (total === 0) {
      return 0;
    }

    return (correct / total) * 100;
  };

  const formatThematicUnit = (thematicUnit, ellipsis = false) => {
    const text = thematicUnit.name || "(Sem unidade temática)";

    if (!ellipsis || text.length < 50) return text;

    return `${text.substring(0, 50)}...`;
  };

  const getPercentageCorrectUnit = thematicUnitId => {
    if (!dataCorrectsUnit.applications || !dataCorrectsUnit.thematic_units) {
      return 0;
    }

    const correct =
      dataCorrectsUnit.applications.find(
        item => item.thematic_unit_id === thematicUnitId && item.correct
      )?.count || 0;
    const notCorrect =
      dataCorrectsUnit.applications.find(
        item => item.thematic_unit_id === thematicUnitId && !item.correct
      )?.count || 0;
    const total = correct + notCorrect;

    if (total === 0) {
      return 0;
    }

    return (correct / total) * 100;
  };

  const getCorrectsUnit = thematicUnitId => {
    if (!dataCorrectsUnit.applications || !dataCorrectsUnit.thematic_units) {
      return "";
    }

    const correct = dataCorrectsUnit.applications.find(
      item => item.thematic_unit_id === thematicUnitId && item.correct
    )?.count;

    return correct || 0;
  };

  const getPercentageStudentAbility = (abilityId, type) => {
    if (!dataStudentAbility[type] || !dataStudentAbility.abilities) {
      return 0;
    }
    // teste de issues
    const correct =
      dataStudentAbility[type].find(
        item => item.ability_id === abilityId && item.correct
      )?.count || 0;
    const notCorrect =
      dataStudentAbility[type].find(
        item => item.ability_id === abilityId && !item.correct
      )?.count || 0;
    const total = correct + notCorrect;

    if (total === 0) {
      return 0;
    }

    return Math.round((correct / total) * 100);
  };

  const [formattedHistogram, selectedStudentBracket] = useMemo(() => {
    if (!dataHistogramStudent?.grades) return [];

    const histogramArray = new Array(11).fill(0);
    const selectedBracket = new Array(11).fill(0);

    const grade =
      dataHistogramStudent.grades?.find(
        item => item.user_id === selected.userId
      )?.grade || 0;
    const gradeBracket = Math.floor(grade);

    dataHistogramStudent.grades.forEach(item => {
      if (Math.floor(item.grade) === gradeBracket)
        selectedBracket[Math.floor(Number(item.grade))] += 1;
      else histogramArray[Math.floor(Number(item.grade))] += 1;
    });

    return [histogramArray, selectedBracket];
  }, [dataHistogramStudent]);

  const labels = useMemo(() => {
    const labelsArray = [];

    for (let index = 0; index < dataHistogramStudent.max; index++) {
      labelsArray.push(
        `De ${dataHistogramStudent.max * 0.1 * index} a ${(
          dataHistogramStudent.max * 0.1 * index +
          0.9
        ).toFixed(1)}`
      );
    }

    labelsArray.push(dataHistogramStudent.max);

    return labelsArray;
  }, [dataHistogramStudent]);

  const changeActivity = selected => {
    setActivityId(selected);
  };

  const openStatistics = () => {
    if (activityId === 0) {
      toastr.error(
        "Erro",
        "Selecione uma avaliação para visualizar as estatísticas"
      );
    } else {
      setStatisticsModal(true);
    }
  };

  const randomColors = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return { r, g, b };
  };

  const getColors = numColors => {
    const colors = [];
    for (let i = 0; i < numColors; i++) {
      colors.push(randomColors());
    }
    return colors;
  };

  const applyOpacity = (colors, opacity) =>
    colors.map(color => `rgba(${color.r}, ${color.g}, ${color.b}, ${opacity})`);

  const numColors = 30;
  const baseColors = getColors(numColors);
  let bgColors = applyOpacity(baseColors, 0.2);
  let bdColors = applyOpacity(baseColors, 1);

  return (
    <>
      {statisticsModal && (
        <Statistics
          show
          onClose={() => setStatisticsModal(false)}
          activity_id={activityId}
          currentRoute={props.currentRoute}
          title={evaluationList.find(item => item.id === activityId)?.name}
        />
      )}

      <Breadcrumb current={props.currentRoute} />
      <div className="d-flex no-print flex-column">
        <div>
          <h2>Relatório de Avaliação</h2>
          <p className="text-muted">
            Crie e visualize relatórios de avaliações.
          </p>
        </div>
        <div className="d-inline-flex align-items-end justify-content-between mt-2">
          <div className="w-75">
            <Label className="d-block w-100 text-ellipsis">Avaliação</Label>
            <InputGroup className="w-100">
              <Select
                value={evaluationList.find(item => item.id === activityId)}
                placeholder="Selecione uma avaliação"
                onChange={e => changeActivity(parseInt(e.id))}
                options={evaluationList
                  .filter(item => item.private === false)
                  .sort((a, b) => a.name.localeCompare(b.name))}
                getOptionLabel={option => option.name}
                getOptionValue={option => option.id}
                isLoading={loading}
                loadingMessage={() => "Carregando..."}
              />
            </InputGroup>
          </div>
          <div>
            <CButton
              color="secondary"
              onClick={openStatistics}
              className="mr-2"
            >
              <i className="fa fa-bar-chart mr-2"></i>+ Estatísticas
            </CButton>
            <CButton
              color="primary"
              onClick={() => window.print()}
              disabled={loading}
            >
              <i className="fa fa-print mr-2"></i>
              Imprimir
            </CButton>
          </div>
        </div>
        <div className="row my-3 w-100">
          <div className="col-12">
            {activityId > 0 && (
              <StatisticFiltersCompare
                key={activityId}
                activityId={activityId}
                onChange={changeFilter}
              />
            )}
          </div>
        </div>
      </div>
      {loading ? (
        <LoadingStatistics />
      ) : selected.userId > 0 ? (
        <>
          <HeaderReport
            title={evaluationList.map(
              item => item.id === activityId && item.name
            )}
            dataGrades={dataGrades}
            selected={selected}
            photo={photo}
          />
          {dataComparisonStudentRoom.user && (
            <div className="row">
              <div className="chart col-12">
                <Charts
                  legendY="Nota Média"
                  legendX=""
                  type="bar"
                  title="Comparação de Notas com Estudante"
                  data={{
                    labels: [""],
                    datasets: [
                      {
                        data: [
                          Number(dataComparisonStudentRoom.user),
                          Number(dataComparisonStudentRoom.max)
                        ],
                        label: "Estudante",
                        backgroundColor: ["rgba(255, 99, 132, 0.2)"],
                        borderColor: ["rgba(255, 99, 132, 1)"],
                        borderWidth: 1
                      },
                      {
                        data: [Number(dataComparisonStudentRoom.room)],
                        label: "Turma",
                        backgroundColor: ["rgba(54, 162, 235, 0.2)"],
                        borderColor: ["rgba(54, 162, 235, 1)"],
                        borderWidth: 1
                      },
                      {
                        data: [Number(dataComparisonStudentRoom.school)],
                        label: "Escola",
                        backgroundColor: ["rgba(255, 206, 86, 0.2)"],
                        borderColor: ["rgba(255, 206, 86, 1)"],
                        borderWidth: 1
                      },
                      {
                        data: [Number(dataComparisonStudentRoom.region)],
                        label: "Estado",
                        backgroundColor: ["rgba(75, 192, 192, 0.2)"],
                        borderColor: ["rgba(75, 192, 192, 1)"],
                        borderWidth: 1
                      },
                      {
                        data: [Number(dataComparisonStudentRoom.group)],
                        label: "Brasil",
                        backgroundColor: ["rgba(153, 102, 255, 0.2)"],
                        borderColor: ["rgba(153, 102, 255, 1)"],
                        borderWidth: 1
                      }
                    ]
                  }}
                />
              </div>
            </div>
          )}
          {dataStudentAbility && (
            <div className="row">
              <div className="chart col-12">
                <Charts
                  legendY="Habilidade"
                  legendX="Acertos %"
                  type="horizontalbar2"
                  title="Acertos por habilidade"
                  data={{
                    labels: dataStudentAbility.abilities.map(
                      ability => ability.code || "(Sem habilidade)"
                    ),
                    datasets: [
                      {
                        data: [
                          ...dataStudentAbility.abilities.map(ability =>
                            getPercentageStudentAbility(
                              ability.ability_id,
                              "user"
                            )
                          ),
                          100
                        ],
                        label: "Estudante",
                        backgroundColor: "rgba(255, 99, 132, 0.2)",
                        borderColor: "rgba(255, 99, 132, 1)",
                        borderWidth: 1
                      },
                      {
                        data: [
                          ...dataStudentAbility.abilities.map(ability =>
                            getPercentageStudentAbility(
                              ability.ability_id,
                              "room"
                            )
                          ),
                          100
                        ],
                        label: "Turma",
                        backgroundColor: "rgba(54, 162, 235, 0.2)",
                        borderColor: "rgba(54, 162, 235, 1)",
                        borderWidth: 1
                      },
                      {
                        data: [
                          ...dataStudentAbility.abilities.map(ability =>
                            getPercentageStudentAbility(
                              ability.ability_id,
                              "school"
                            )
                          ),
                          100
                        ],
                        label: "Escola",
                        backgroundColor: "rgba(255, 206, 86, 0.2)",
                        borderColor: "rgba(255, 206, 86, 1)",
                        borderWidth: 1
                      },
                      {
                        data: [
                          ...dataStudentAbility.abilities.map(ability =>
                            getPercentageStudentAbility(
                              ability.ability_id,
                              "region"
                            )
                          ),
                          100
                        ],
                        label: "Estado",
                        backgroundColor: "rgba(75, 192, 192, 0.2)",
                        borderColor: "rgba(75, 192, 192, 1)",
                        borderWidth: 1
                      },
                      {
                        data: [
                          ...dataStudentAbility.abilities.map(ability =>
                            getPercentageStudentAbility(
                              ability.ability_id,
                              "group"
                            )
                          ),
                          100
                        ],
                        label: "Brasil",
                        backgroundColor: "rgba(153, 102, 255, 0.2)",
                        borderColor: "rgba(153, 102, 255, 1)",
                        borderWidth: 1
                      }
                    ].filter(item => item !== null)
                  }}
                />
              </div>
              <div className="col-12 my-2">
                <table className="table table-hover table-outline mb-0 d-none d-sm-table w-100">
                  <thead className="thead-light">
                    <th>Habilidade</th>
                  </thead>
                  <tbody>
                    {dataStudentAbility.abilities?.map((ability, index) => (
                      <tr>
                        <td>{formatAbility(ability)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="page-break"></div>
          <HeaderReport
            title={evaluationList.map(
              item => item.id === activityId && item.name
            )}
            dataGrades={dataGrades}
            selected={selected}
            photo={photo}
          />
          {dataHistogramStudent && (
            <div className="row">
              <div className="chart col-12">
                <Charts
                  legendX="Nota"
                  legendY="Total de estudantes"
                  type="bar"
                  title="Distribuição de notas"
                  data={{
                    labels,
                    datasets: [
                      {
                        data: formattedHistogram,
                        label: "Distribuição de notas",
                        backgroundColor: "rgba(54, 162, 235, 0.2)",
                        borderColor: "rgba(54, 162, 235, 1)",
                        borderWidth: 1
                      },
                      {
                        data: selectedStudentBracket,
                        label: "Estudante selecionado",
                        backgroundColor: "rgba(255, 99, 132, 0.2)",
                        borderColor: "rgba(255, 99, 132, 1)",
                        borderWidth: 1
                      }
                    ]
                  }}
                />
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {dataComparison &&
            dataComparison.rooms &&
            (selected.roomId > 0 || selected.schoolId > 0) && (
              <>
                <HeaderReport
                  title={evaluationList.map(
                    item => item.id === activityId && item.name
                  )}
                  dataGrades={dataGrades}
                  selected={selected}
                  photo={photo}
                />
                {dataGrades?.summary && (
                  <>
                    <h5 className="text-muted mb-2">Resumo da avaliação</h5>
                    <section className="p-3 border rounded-lg d-flex flex-column mb-3">
                      <div className="summary-report d-flex justify-content-between">
                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                          <h3 className="m-0 font-weight-semibold">
                            {dataGrades.summary.avg_school_grade !== null
                              ? Number(
                                  dataGrades.summary.avg_school_grade
                                ).toFixed(2)
                              : ""}
                          </h3>
                          <small className="text-muted">Média da Escola</small>
                        </div>

                        <div
                          className="bg-light mx-3"
                          style={{
                            minWidth: "1px",
                            height: "4rem",
                            borderRadius: "0.5px"
                          }}
                        />

                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                          <h3 className="m-0 font-weight-semibold">
                            {dataGrades.summary.avg_region_grade !== null
                              ? Number(
                                  dataGrades.summary.avg_region_grade
                                ).toFixed(2)
                              : ""}
                          </h3>
                          <small className="text-muted">Média do Estado</small>
                        </div>

                        <div
                          className="bg-light mx-3"
                          style={{
                            minWidth: "1px",
                            height: "4rem",
                            borderRadius: "0.5px"
                          }}
                        />

                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                          <h3 className="m-0 font-weight-semibold">
                            {dataGrades.summary.avg_group_grade !== null
                              ? Number(
                                  dataGrades.summary.avg_group_grade
                                ).toFixed(2)
                              : ""}
                          </h3>
                          <small className="text-muted">Média Nacional</small>
                        </div>
                      </div>
                    </section>
                    <section className="p-3 border rounded-lg d-flex flex-column mb-3">
                      <div className="summary-report d-flex justify-content-between">
                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                          <h3
                            className={`m-0 font-weight-semibold ${
                              (dataGrades.summary.num_applications /
                                dataGrades.summary.total) *
                                100 <
                              50
                                ? "text-danger"
                                : (dataGrades.summary.num_applications /
                                    dataGrades.summary.total) *
                                    100 <
                                  75
                                ? "text-warning"
                                : "text-success"
                            }`}
                          >
                            {Number(
                              (dataGrades.summary.num_applications /
                                dataGrades.summary.total) *
                                100
                            ).toFixed(2)}
                            %
                          </h3>
                          <small className="text-muted">Participação</small>
                        </div>

                        <div
                          className="bg-light mx-3"
                          style={{
                            minWidth: "1px",
                            height: "4rem",
                            borderRadius: "0.5px"
                          }}
                        />

                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                          <h3
                            className={`m-0 font-weight-semibold ${
                              dataGrades.summary.avg_grade < 4
                                ? "text-danger"
                                : dataGrades.summary.avg_grade < 7
                                ? "text-warning"
                                : "text-success"
                            }`}
                          >
                            {dataGrades.summary.avg_grade !== null
                              ? Number(dataGrades.summary.avg_grade).toFixed(2)
                              : ""}
                          </h3>
                          <small className="text-muted">Média</small>
                        </div>

                        <div
                          className="bg-light mx-3"
                          style={{
                            minWidth: "1px",
                            height: "4rem",
                            borderRadius: "0.5px"
                          }}
                        />

                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                          <h3
                            className={`m-0 font-weight-semibold ${
                              dataGrades.summary.max_grade < 4
                                ? "text-danger"
                                : dataGrades.summary.max_grade < 7
                                ? "text-warning"
                                : "text-success"
                            }`}
                          >
                            {dataGrades.summary.max_grade !== null
                              ? Number(dataGrades.summary.max_grade).toFixed(2)
                              : ""}
                          </h3>
                          <small className="text-muted">Maior nota</small>
                        </div>

                        <div
                          className="bg-light mx-3"
                          style={{
                            minWidth: "1px",
                            height: "4rem",
                            borderRadius: "0.5px"
                          }}
                        />

                        <div className="d-flex flex-column align-items-center justify-content-center w-100">
                          <h3
                            className={`m-0 font-weight-semibold ${
                              dataGrades.summary.min_grade < 4
                                ? "text-danger"
                                : dataGrades.summary.min_grade < 7
                                ? "text-warning"
                                : "text-success"
                            }`}
                          >
                            {dataGrades.summary.min_grade !== null
                              ? Number(dataGrades.summary.min_grade).toFixed(2)
                              : ""}
                          </h3>
                          <small className="text-muted">Menor nota</small>
                        </div>
                      </div>
                    </section>
                  </>
                )}
                {selected.roomId > 0 && (
                  <>
                    {dataGrades && dataGrades.grades && (
                      <div className="w-100">
                        <h5 className="text-muted mb-2">Lista de notas</h5>
                        <div className="w-100" id="porAluno">
                          <table className="table table-hover table-outline mb-0 d-none d-sm-table w-100 mb-4">
                            <thead className="thead-light">
                              <tr>
                                <th>Nº</th>
                                <th>Estudante</th>
                                <th>Nota</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dataGrades.grades.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="c-avatar mr-3">
                                        <img
                                          src={
                                            URL.img +
                                            (item.photo ||
                                              "uploads/users/profileEmpty.jpg")
                                          }
                                          className="c-avatar-img"
                                          alt="imagem"
                                        />
                                      </div>
                                      {item.name}
                                    </div>
                                  </td>
                                  <td>{item.grade}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="w-100">
                  <h5 className="text-muted mb-2">Comparação entre turmas</h5>
                  <div className="flex-column w-100 mb-4">
                    <div className="row">
                      <div className="chart col-12">
                        <Charts
                          legendY=""
                          legendX="Média da Nota"
                          title=""
                          type="horizontalbar"
                          data={{
                            labels:
                              dataComparison.rooms.map(
                                (room, index) => room.name
                              ) || [],
                            datasets: [
                              {
                                data: [
                                  ...(dataComparison.rooms.map(
                                    room => room.grade
                                  ) || []),
                                  dataComparison.max
                                ],
                                backgroundColor: bgColors,
                                borderColor: bdColors,
                                borderWidth: 1
                              }
                            ]
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="page-break"></div>
              </>
            )}

          {dataComparison &&
            dataComparison.schools &&
            selected.schoolId === 0 &&
            selected.regionId > 0 && (
              <>
                <HeaderReport
                  title={evaluationList.map(
                    item => item.id === activityId && item.name
                  )}
                  dataGrades={dataGrades}
                  selected={selected}
                  photo={photo}
                />
                <div className="w-100">
                  <h5 className="text-muted mb-2">Comparação entre escolas</h5>
                  <div className="flex-column w-100 mb-4">
                    <div className="row">
                      <div className="chart col-12">
                        <Charts
                          legendY=""
                          legendX="Média da Nota"
                          title=""
                          type="horizontalbar"
                          data={{
                            labels:
                              dataComparison.schools.map(
                                (school, index) => school.name
                              ) || [],
                            datasets: [
                              {
                                data: [
                                  ...(dataComparison.schools.map(
                                    school => school.grade
                                  ) || []),
                                  dataComparison.max
                                ],
                                backgroundColor: bgColors,
                                borderColor: bdColors,
                                borderWidth: 1
                              }
                            ]
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="page-break"></div>
              </>
            )}

          {dataComparison &&
            dataComparison.regions &&
            selected.regionId === 0 && (
              <>
                <HeaderReport
                  title={evaluationList.map(
                    item => item.id === activityId && item.name
                  )}
                  dataGrades={dataGrades}
                  selected={selected}
                  photo={photo}
                />
                <div className="w-100">
                  <h5 className="text-muted mb-2">Comparação entre regiões</h5>
                  <div className="flex-column w-100 mb-4">
                    <div className="row">
                      <div className="chart col-12">
                        <Charts
                          legendY=""
                          legendX="Média da Nota"
                          title=""
                          type="horizontalbar"
                          data={{
                            labels:
                              dataComparison.regions.map(
                                (region, index) => region.name
                              ) || [],
                            datasets: [
                              {
                                data: [
                                  ...(dataComparison.regions.map(
                                    region => region.grade
                                  ) || []),
                                  dataComparison.max
                                ],
                                backgroundColor: bgColors,
                                borderColor: bdColors,
                                borderWidth: 1
                              }
                            ]
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="page-break"></div>
              </>
            )}

          {dataCorrectsByQuestion && dataCorrectsByQuestion.questions && (
            <>
              <HeaderReport
                title={evaluationList.map(
                  item => item.id === activityId && item.name
                )}
                dataGrades={dataGrades}
                selected={selected}
                photo={photo}
              />
              <div className="w-100">
                <h5 className="text-muted mb-2">Acertos por questão</h5>
                <div className="flex-column w-100 mb-4">
                  <div className="chart col-12">
                    <Charts
                      legendY=""
                      legendX="Acertos %"
                      type="horizontalbar"
                      title=""
                      data={{
                        labels:
                          dataCorrectsByQuestion.questions?.map(
                            (question, index) => `Questão ${index + 1}`
                          ) || [],
                        datasets: [
                          {
                            data: [
                              ...(dataCorrectsByQuestion.questions?.map(
                                question => getPercentage(question.question_id)
                              ) || []),
                              100
                            ],
                            backgroundColor: bgColors,
                            borderColor: bdColors,
                            borderWidth: 1
                          }
                        ]
                      }}
                    />
                  </div>
                  <div className="w-100" style={{ marginBottom: "40px" }}>
                    <table className="table table-hover table-outline mb-0 d-none d-sm-table acertosPorQuestao w-100">
                      <thead className="thead-light">
                        <th>Questão</th>
                        <th>Total de acertos</th>
                        <th>%</th>
                      </thead>
                      <tbody>
                        {dataCorrectsByQuestion.questions?.map(
                          (question, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td className="">
                                {getCorrects(question.question_id)}
                              </td>
                              <td>
                                <div className="clearfix">
                                  <div className="float-left">
                                    {getPercentage(
                                      question.question_id
                                    ).toFixed(0)}
                                    %
                                  </div>
                                </div>
                                <CProgress
                                  className="progress-xs"
                                  color={
                                    getPercentage(question.question_id).toFixed(
                                      0
                                    ) > 50
                                      ? "success"
                                      : getPercentage(
                                          question.question_id
                                        ).toFixed(0) <= 50 &&
                                        getPercentage(
                                          question.question_id
                                        ).toFixed(0) >= 30
                                      ? "warning"
                                      : "danger"
                                  }
                                  value={getPercentage(
                                    question.question_id
                                  ).toFixed(0)}
                                />
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="page-break"></div>

          {dataCorrectsByAbility && dataCorrectsByAbility.abilities && (
            <>
              <HeaderReport
                title={evaluationList.map(
                  item => item.id === activityId && item.name
                )}
                dataGrades={dataGrades}
                selected={selected}
                photo={photo}
              />
              <div className="w-100">
                <h5 className="text-muted mb-2">Acertos por habilidade</h5>
                <div className="flex-column w-100">
                  <div className="chart col-12">
                    <Charts
                      legendY=""
                      legendX="Acertos %"
                      type="horizontalbar"
                      title=""
                      data={{
                        labels: dataCorrectsByAbility.abilities.map(
                          ability => ability.code || "(Sem habilidade)"
                        ),
                        datasets: [
                          {
                            data: [
                              ...(dataCorrectsByAbility.abilities?.map(
                                ability =>
                                  getPercentageAbility(ability.ability_id)
                              ) || []),
                              100
                            ],
                            backgroundColor: bgColors,
                            borderColor: bdColors,
                            borderWidth: 1
                          }
                        ]
                      }}
                    />
                  </div>
                </div>
                <div className="w-100" style={{ marginBottom: "40px" }}>
                  <table className="table table-hover table-outline mb-0 d-none d-sm-table acertosPorQuestao w-100">
                    <thead className="thead-light">
                      <th>Habilidade</th>
                      <th>Acertos</th>
                      <th>%</th>
                    </thead>
                    <tbody>
                      {dataCorrectsByAbility.abilities?.map(
                        (ability, index) => (
                          <tr>
                            <td>{formatAbility(ability)}</td>
                            <td className="">
                              {getCorrectsAbility(ability.ability_id)}
                            </td>
                            <td>
                              <div className="clearfix">
                                <div className="float-left">
                                  {getPercentageAbility(
                                    ability.ability_id
                                  ).toFixed(0)}
                                  %
                                </div>
                              </div>
                              <CProgress
                                className="progress-xs"
                                color={
                                  getPercentageAbility(
                                    ability.ability_id
                                  ).toFixed(0) > 50
                                    ? "success"
                                    : getPercentageAbility(
                                        ability.ability_id
                                      ).toFixed(0) <= 50 &&
                                      getPercentageAbility(
                                        ability.ability_id
                                      ).toFixed(0) >= 30
                                    ? "warning"
                                    : "danger"
                                }
                                value={getPercentageAbility(
                                  ability.ability_id
                                ).toFixed(0)}
                              />
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
          <div className="page-break"></div>

          {dataCorrectsUnit && dataCorrectsUnit.thematic_units && (
            <>
              <HeaderReport
                title={evaluationList.map(
                  item => item.id === activityId && item.name
                )}
                dataGrades={dataGrades}
                selected={selected}
                photo={photo}
              />
              <div className="w-100">
                <h5 className="text-muted mb-2">
                  Acertos por unidade temática
                </h5>
                <div className="flex-column w-100">
                  <div className="chart col-12">
                    <Charts
                      legendY=""
                      legendX="Acertos %"
                      type="horizontalbar"
                      title=""
                      data={{
                        labels:
                          dataCorrectsUnit.thematic_units?.map(
                            (thematicUnit, index) =>
                              formatThematicUnit(thematicUnit, true)
                          ) || [],
                        datasets: [
                          {
                            data: [
                              ...(dataCorrectsUnit.thematic_units?.map(
                                thematicUnit =>
                                  getPercentageCorrectUnit(
                                    thematicUnit.thematic_unit_id
                                  )
                              ) || []),
                              100
                            ],
                            backgroundColor: [
                              "rgba(255, 99, 132, 0.2)",
                              "rgba(54, 162, 235, 0.2)",
                              "rgba(255, 206, 86, 0.2)",
                              "rgba(75, 192, 192, 0.2)",
                              "rgba(153, 102, 255, 0.2)",
                              "rgba(255, 159, 64, 0.2)",
                              "rgba(255, 0, 41, 0.2)",
                              "rgba(55, 126, 184, 0.2)",
                              "rgba(102, 166, 30, 0.2)",
                              "rgba(152, 78, 163, 0.2)",
                              "rgba(0, 210, 213, 0.2)",
                              "rgba(255, 127, 0, 0.2)",
                              "rgba(254, 224, 182, 0.2)",
                              "rgba(127, 128, 205, 0.2)",
                              "rgba(179, 233, 0, 0.2)",
                              "rgba(196, 46, 96, 0.2)"
                            ],
                            borderColor: [
                              "rgba(255, 99, 132, 1)",
                              "rgba(54, 162, 235, 1)",
                              "rgba(255, 206, 86, 1)",
                              "rgba(75, 192, 192, 1)",
                              "rgba(153, 102, 255, 1)",
                              "rgba(255, 159, 64, 1)",
                              "rgba(255, 0, 41, 1)",
                              "rgba(55, 126, 184, 1)",
                              "rgba(102, 166, 30, 1)",
                              "rgba(152, 78, 163, 1)",
                              "rgba(0, 210, 213, 1)",
                              "rgba(255, 127, 0, 1)",
                              "rgba(254, 224, 182, 1)",
                              "rgba(127, 128, 205, 1)",
                              "rgba(179, 233, 0, 1)",
                              "rgba(196, 46, 96, 1)"
                            ],
                            borderWidth: 1
                          }
                        ]
                      }}
                    />
                  </div>
                  <div className="col-12">
                    <table className="table table-hover table-outline mb-0 d-none d-sm-table acertosPorQuestao w-100">
                      <thead className="thead-light">
                        <th>Unidade Temática</th>
                        <th>Acertos</th>
                        <th>%</th>
                      </thead>
                      <tbody>
                        {dataCorrectsUnit.thematic_units?.map(
                          (thematicUnit, index) => (
                            <tr>
                              <td>{formatThematicUnit(thematicUnit)}</td>
                              <td className="">
                                {getCorrectsUnit(thematicUnit.thematic_unit_id)}
                              </td>
                              <td>
                                <div className="clearfix">
                                  <div className="float-left">
                                    {getPercentageCorrectUnit(
                                      thematicUnit.thematic_unit_id
                                    ).toFixed(0)}
                                    %
                                  </div>
                                </div>
                                <CProgress
                                  className="progress-xs"
                                  color={
                                    getPercentageCorrectUnit(
                                      thematicUnit.thematic_unit_id
                                    ).toFixed(0) > 50
                                      ? "success"
                                      : getPercentageCorrectUnit(
                                          thematicUnit.thematic_unit_id
                                        ).toFixed(0) <= 50 &&
                                        getPercentageCorrectUnit(
                                          thematicUnit.thematic_unit_id
                                        ).toFixed(0) >= 30
                                      ? "warning"
                                      : "danger"
                                  }
                                  value={getPercentageCorrectUnit(
                                    thematicUnit.thematic_unit_id
                                  ).toFixed(0)}
                                />
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="page-break"></div>

          {dataDescriptor.questions && (
            <>
              <HeaderReport
                title={evaluationList.map(
                  item => item.id === activityId && item.name
                )}
                dataGrades={dataGrades}
                selected={selected}
                photo={photo}
              />
              <div className="w-100 mt-2">
                <h5 className="text-muted mb-2">Descritor e Distrator</h5>
                {dataDescriptor.questions.map((question, index) => (
                  <div className="p-4 w-100" key={question.id}>
                    <h4 className="font-weight-bold">Questão {index + 1}</h4>
                    <p>
                      <TextEditorReadOnly
                        editorType={{ name: "description", id: 1 }}
                        questionId={question.id}
                        textContent={question.description}
                      />
                      <CBadge
                        color="secondary"
                        className="p-2 w-100 text-left"
                        style={{ whiteSpace: "normal" }}
                      >
                        {question.ability_description}
                      </CBadge>
                    </p>
                    <CListGroup>
                      {question.options.map(option => (
                        <CListGroupItem
                          className={
                            option.check_value
                              ? "bg-primary"
                              : isDistractor(question, option)
                              ? "list-group-item-warning"
                              : ""
                          }
                          key={option.id}
                          style={{ marginTop: "1px" }}
                        >
                          <TextEditorReadOnly
                            editorType={{ name: "description", id: 1 }}
                            questionId={option.id}
                            textContent={option.description}
                            style={{ margin: 0 }}
                          />
                          A porcentagem de estudantes que marcaram essa
                          alternativa foi de:{" "}
                          <strong>
                            {getOptionPercentage(question, option).toFixed(2)}%
                          </strong>
                        </CListGroupItem>
                      ))}
                    </CListGroup>
                    <div className="page-break"></div>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

function HeaderReport({ title, dataGrades, selected, photo }) {
  return (
    <>
      <CCard className="d-none print-only">
        <CCardHeader className="d-flex align-items-center justify-content-between p-4">
          <div className="d-inline-flex align-items-center">
            <div className="flex-1 my-auto mr-2">
              <img src={URL.img + photo} />
            </div>
            {dataGrades.summary && (
              <div className="d-flex w-100 flex-column">
                <CCardSubtitle>
                  {
                    selected.hierarchy[0].regions
                      .find(region => region.id === selected.regionId)
                      ?.schools.find(school => school.id === selected.schoolId)
                      ?.name
                  }
                </CCardSubtitle>
                <CCardSubtitle className="small my-2">
                  {
                    selected.hierarchy[0].regions.find(
                      item => item.id === selected.regionId
                    )?.name
                  }
                </CCardSubtitle>
                <CCardSubtitle className="small">
                  {
                    selected.hierarchy[0].regions
                      .find(region => region.id === selected.regionId)
                      ?.schools.find(school => school.id === selected.schoolId)
                      ?.rooms.find(room => room.id === selected.roomId)?.name
                  }
                </CCardSubtitle>
              </div>
            )}
          </div>
          <div className="d-flex-column justify-content-between">
            <CCardSubtitle className="small mb-2">{title}</CCardSubtitle>
            <CCardSubtitle className="small">
              Última atualização: {new Date().toLocaleString()}
            </CCardSubtitle>
          </div>
        </CCardHeader>
      </CCard>
    </>
  );
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

EvaluationADRReport.defaultProps = {
  hideLayout: false
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationADRReport);
